import { useCallback } from 'react';
import { To, useNavigate } from 'react-router-dom';

export function useBackNavigation(fallback: To) {
  const navigate = useNavigate();
  return useCallback(() => {
    const idx = (typeof window !== 'undefined' && window.history?.state?.idx) ?? 0;
    if (idx > 0) {
      navigate(-1);
    } else {
      navigate(fallback);
    }
  }, [navigate, fallback]);
}
